import { render } from "./UserStatistics.vue?vue&type=template&id=97e07522&scoped=true&ts=true"
import script from "./UserStatistics.vue?vue&type=script&lang=ts"
export * from "./UserStatistics.vue?vue&type=script&lang=ts"

import "./UserStatistics.vue?vue&type=style&index=0&id=97e07522&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e07522"]])

export default __exports__